import { useContext, useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { FiHome, FiEdit, FiEdit3, FiUser, FiUserPlus, FiLogOut, FiCheck } from 'react-icons/fi'

import { AuthContext } from '../../contexts/auth'

import avatarImg from '../../assets/avatar.png'

import { SideBar } from './styles'

export function Header2() {
  const { logOut, user } = useContext(AuthContext)
  const navigate = useNavigate()

  //const [dataUser, setDataUser] = useState(null)
  //console.log(dataUser.adm)
  //console.log(user.status)

  // useEffect(() => {
  //   async function loadDataUser() {
  //     const dataUserStorage = localStorage.getItem("@dataUser")

  //     if (dataUserStorage) {
  //       setDataUser(JSON.parse(dataUserStorage))
  //     }
  //   }

  //   loadDataUser()
  // }, [])

  async function handleLogOut() {
    await logOut()
  }

  function handleInitial() {
    navigate('/')
  }

  function signOut() {
    localStorage.clear("dataUser")


  }

  return (
    <SideBar>
      <div className='background-avatar'>
        {/* <img src={avatarImg} alt="foto do perfil" /> */}
        <img src={avatarImg} alt="foto do perfil" />
      </div>

      {/* <Link to="/dashboard">
        <FiHome size={25} />
        Inicio
      </Link> */}
      <Link to="/questoes-publicas" >
        <FiCheck size={25} />
        Questões
      </Link>

      {/* <Link to="/perfil">
        <FiUser size={25} />
        Perfil
      </Link> */}
      {/* <Link to="/dashboard">
        <FiHome size={25} />
        Inicio
      </Link> */}
      <Link onClick={signOut} to="https://pantheonconcursos.com.br/" >
        <FiLogOut size={25} />
        Sair
      </Link>

    </SideBar>
  )
}